<section [class]="classList">
  <button [type]="type()" [disabled]="disable()" [class]="button_style()" (click)="onClick($event)">
    <ng-content></ng-content>
  </button>
</section>
